const getters = {
  user: (state) => state.user.user,
  initData: (state) => state.settings.initData,
  name: (state) => state.user.user.userName,
  router: (state) => state.router.router,
};
export default getters;
